import { ColorV2, Text } from "@adoptaunabuelo/react-components";
import { ProductScheme } from "client-v2";
import { useEffect, useState } from "react";
import styled from "styled-components";
import media from "styled-media-query";
import ReliefModal from "../../components/modal/ReliefModal";

const Container = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	padding: 24px 24px 24px 40px;
	width: 400px;
`;
const CellContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 8px;
`;
const Cell = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-end;
`;
const Line = styled.div`
	display: flex;
	flex: 1;
	border-bottom: 1px dashed ${ColorV2.surface.neutralLow};
	margin: 0px 16px;
	min-width: 32px;
	${media.lessThan("small")`
        margin: 0px 8px;
		min-width: 12px;
    `}
`;

const PriceResume = (props: PriceResumeProps) => {
	const [data, setData] = useState<
		{ title: string; amount: string; color?: string }[]
	>([]);
	const [totalPrice, setTotalPrice] = useState<string | undefined>(undefined);
	const [showReliefModal, setShowReliefModal] = useState(false);

	useEffect(() => {
		calculateData();
	}, [props.shipping]);

	const calculateData = () => {
		const tempCurrencyName = "EUR";
		const conversion = 1;
		const tempLanguage = "es-ES";
		const tempPrice = props.product.data
			? props.product.data[tempCurrencyName].price
			: 0;
		const tempAmbassadorPrice = props.isSubscriptor
			? props.product.data
				? props.product.data[tempCurrencyName].ambassadorPrice || 0
				: 0
			: 0;

		const tempSubtotal = tempPrice + (props.shipping?.amount || 0);
		const subtotalPrice = new Intl.NumberFormat(tempLanguage, {
			style: "currency",
			currency: tempCurrencyName,
			maximumFractionDigits: 2,
		}).format(tempSubtotal);

		const taxPrice = new Intl.NumberFormat(tempLanguage, {
			style: "currency",
			currency: tempCurrencyName,
			maximumFractionDigits: 2,
		}).format((tempSubtotal * 0.21) / conversion);

		const temp = props.isSubscriptor
			? tempAmbassadorPrice * 1.21
			: tempSubtotal * 1.21;
		const totalPrice = new Intl.NumberFormat(tempLanguage, {
			style: "currency",
			currency: tempCurrencyName,
			maximumFractionDigits: 2,
		}).format(temp / conversion);
		setTotalPrice(totalPrice);

		const ambassadorPrice = new Intl.NumberFormat(tempLanguage, {
			style: "currency",
			currency: tempCurrencyName,
			maximumFractionDigits: 2,
		}).format(
			(tempAmbassadorPrice * 1.21 - tempSubtotal * 1.21) / conversion
		);

		const tempData: typeof data = [
			{
				title: "Coste del Pack",
				amount: new Intl.NumberFormat(tempLanguage, {
					style: "currency",
					currency: tempCurrencyName,
					maximumFractionDigits: 2,
				}).format(8.71 / conversion),
			},
			{
				title: "Comisión bancaria",
				amount: new Intl.NumberFormat(tempLanguage, {
					style: "currency",
					currency: tempCurrencyName,
					maximumFractionDigits: 2,
				}).format(0.66 / conversion),
			},
			{
				title: "Envío de ida y vuelta",
				amount: new Intl.NumberFormat(tempLanguage, {
					style: "currency",
					currency: tempCurrencyName,
					maximumFractionDigits: 2,
				}).format(6.31 / conversion),
			},
			{
				title: "Donación a los programas sociales de la Fundación",
				amount: new Intl.NumberFormat(tempLanguage, {
					style: "currency",
					currency: tempCurrencyName,
					maximumFractionDigits: 2,
				}).format(8.29 / conversion),
			},
			{
				title: "",
				amount: "",
			},
			{
				title: "Subtotal",
				amount: subtotalPrice,
			},
			{
				title: "Impuestos 21% IVA",
				amount: taxPrice,
			},
		];

		if (props.isSubscriptor) {
			tempData.push({
				title: "",
				amount: "",
			});
			tempData.push({
				title: "Descuento por embajador",
				amount: ambassadorPrice,
				color: ColorV2.text.primary,
			});
		}
		tempData.push({
			title: "TOTAL",
			amount: totalPrice,
		});
		setData(tempData);
	};

	return (
		<Container style={props.style}>
			<ReliefModal
				isVisible={showReliefModal}
				price={totalPrice ? parseInt(totalPrice) : 0}
				charge={"one"}
				onClose={() => setShowReliefModal(false)}
			/>
			<Text type="h3" weight="semibold" style={{ marginBottom: 32 }}>
				A qué se destina tu dinero
			</Text>
			<CellContainer>
				{data.map((item, index) => {
					if (item.title === "") {
						return (
							<div
								key={"space-" + index}
								style={{ marginTop: 16 }}
							/>
						);
					} else {
						return (
							<Cell
								key={"subtotal-" + index}
								style={{
									marginTop: item.title === "TOTAL" ? 24 : 0,
								}}
							>
								<Text
									type="p"
									style={{
										fontFamily: "DM Mono",
										fontWeight:
											item.title === "TOTAL" ? 500 : 400,
										color: item.color,
									}}
								>
									{item.title}
								</Text>
								<Line />
								<Text
									type="p"
									style={{
										fontFamily: "DM Mono",
										fontWeight:
											item.title === "TOTAL" ? 500 : 400,
										color: item.color,
									}}
								>
									{item.amount}
								</Text>
							</Cell>
						);
					}
				})}
			</CellContainer>
		</Container>
	);
};
export default PriceResume;
export interface PriceResumeProps {
	product: ProductScheme;
	shipping?: { amount: number; currency: string };
	isSubscriptor: boolean;
	style?: React.CSSProperties;
}
